module.exports = __webpack_public_path__ + "media/CN_005.56f14bcb.mp3";